<template>
  <div v-if="isLoggedIn" class="my-policy-float" @click="goPolicies">
    <span class="mpf-icon">📄</span>
    <span class="mpf-text">我的保单</span>
  </div>
</template>

<script>
export default {
  name: "MyPolicyFloat",
  data() {
    return {
      isLoggedIn: localStorage.getItem("app_login") === "1"
    };
  },
  methods: {
    goPolicies() {
      // 跳转到我的保单（保单查询）页面
      if (this.$route.name === "policy-inquiry") return;
      this.$router.push({ name: "policy-inquiry" });
    }
  }
};
</script>

<style scoped lang="scss">
.my-policy-float {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 2000;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 44px;
  padding: 16px 0;
  background: linear-gradient(180deg, #2f7cff 0%, #1f5fe0 100%);
  color: #fff;
  border-radius: 12px 0 0 12px;
  box-shadow: -4px 4px 16px rgba(31, 95, 224, 0.28);
  cursor: pointer;
  user-select: none;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Microsoft YaHei", sans-serif;
  transition: width 0.2s ease, padding 0.2s ease;

  &:hover {
    width: 50px;
  }

  .mpf-icon {
    font-size: 18px;
    line-height: 1;
  }

  .mpf-text {
    margin-top: 8px;
    writing-mode: vertical-rl;
    letter-spacing: 4px;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
